(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["model-swatches"] && !Shopify.designMode) return;
  try {
    (() => {
    let tooltip = null;
    let activeTarget = null;

    function getOrCreateTooltip() {
      if (!tooltip) {
        tooltip = document.createElement('span');
        tooltip.className = 'variant-option__tooltip';
        tooltip.setAttribute('role', 'tooltip');
        document.body.appendChild(tooltip);
      }
      return tooltip;
    }

    function showTooltip(trigger) {
      const tip = getOrCreateTooltip();
      tip.textContent = trigger.dataset.tooltip;

      const rect = trigger.getBoundingClientRect();
      tip.classList.add('is-visible');

      const tipRect = tip.getBoundingClientRect();
      const left = rect.left + rect.width / 2 - tipRect.width / 2;
      const top = rect.top - tipRect.height - 8;

      tip.style.left = Math.max(8, left) + 'px';
      tip.style.top = top + 'px';

      activeTarget = trigger;
    }

    function hideTooltip() {
      if (tooltip) tooltip.classList.remove('is-visible');
      activeTarget = null;
    }

    document.addEventListener('mouseover', (e) => {
      const trigger = e.target.closest('.variant-option__tooltip-trigger');
      if (trigger) showTooltip(trigger);
    });

    document.addEventListener('mouseout', (e) => {
      if (e.target.closest('.variant-option__tooltip-trigger')) hideTooltip();
    });

    document.addEventListener('click', (e) => {
      const trigger = e.target.closest('.variant-option__tooltip-trigger');
      if (!trigger) {
        hideTooltip();
        return;
      }
      if (activeTarget === trigger) {
        hideTooltip();
      } else {
        showTooltip(trigger);
      }
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["variant-main-picker"] && !Shopify.designMode) return;
  try {
    window.addEventListener("load", () => {
  const urlParams = new URLSearchParams(window.location.search);

  // HIDE expiration date
  const fieldsets = document.querySelectorAll('fieldset.variant-option')
  // fieldsets.forEach(fieldset => {
  //   const legend = fieldset.querySelector('legend')
  //   if(legend.innerText == 'Expiration Date'){
  //     fieldset.style = "display: none"
  //     fieldset.setAttribute('aria-hidden', true)
  //   }
  // });

  // if the PDP has already variant on the query of the URL, it wont change the url
  if (urlParams.has("variant")) return;

  const input = document.querySelector("input[name^='Expiration Date']");
  input.checked = true;
  const variantID = input.dataset.variantId;

  // replicate the user click
  input.dispatchEvent(new Event("change", { bubbles: true }));

  // change search bar
  history.replaceState(null, "", `?variant=${variantID}`);
});
  } catch(e) { console.error(e); }
})();

})();
